import DetailsPanel from '../DetailsPanel/DetailsPanel'
import FilterContainer from '../FilterContainer/FilterContainer'
import './AppContainer.css'

const AppContainer = () => (
  <div className="appContainer">
    <FilterContainer />
    <DetailsPanel />
  </div>
)

export default AppContainer
